import { render, staticRenderFns } from "./serverless-tool-card.vue?vue&type=template&id=413ead3e&"
import script from "./serverless-tool-card.vue?vue&type=script&lang=ts&"
export * from "./serverless-tool-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports